// generated by genversion
const version = '6.15.8';

export { version };
//# sourceMappingURL=version.mjs.map
